<div>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">ورود کارشناس</h2>
      </div>

      <div class="modal-body">
        <h2>اطلاعات خود را وارد کنید</h2>

        <div class="form-group has-icon">
          <span class="form-control-icon">
            <mat-icon>phone_iphone</mat-icon>
          </span>
          <input
            type="search"
            class="form-control"
            [disabled]="isSubmitDisabled"
            #phoneNumberField="ngModel"
            [(ngModel)]="fields.strMobile"
            required
            appPhoneNumberValidation
            [maxLength]="11"
            [ngClass]="phoneNumberField.value ? 'direction-ltr' : ''"
            [minlength]="11"
            inputmode="numeric"
            appNumericOnly
            placeholder="شماره موبایل"
            autofocus
          />
        </div>

        <div class="form-group has-icon">
          <span class="form-control-icon">
            <mat-icon>password</mat-icon>
          </span>
          <input
            type="password"
            class="form-control"
            [disabled]="isSubmitDisabled"
            #passwordField="ngModel"
            [(ngModel)]="fields.strUserPassword"
            required
            placeholder="رمز عبور"
            (keydown.enter)="submit(phoneNumberField, passwordField)"
          />
        </div>

        <div class="links">
          <button
            type="button"
            class="btn"
            [disabled]="
              phoneNumberField.invalid ||
              phoneNumberField.pristine ||
              isSubmitDisabled
            "
            (click)="forgetPassword(phoneNumberField)"
          >
            فراموشی رمز عبور
          </button>
        </div>
      </div>

      <div class="modal-footer d-flex flex-row-reverse justify-content-end">
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="
            phoneNumberField.invalid ||
            passwordField.invalid ||
            phoneNumberField.pristine ||
            passwordField.pristine ||
            isSubmitDisabled
          "
          (click)="submit(phoneNumberField, passwordField)"
        >
          ورود
        </button>
      </div>
    </div>
  </div>
</div>
